import { render, staticRenderFns } from "./MarketplaceChallanLayout.vue?vue&type=template&id=7df4038a&scoped=true&"
import script from "./MarketplaceChallanLayout.vue?vue&type=script&lang=js&"
export * from "./MarketplaceChallanLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df4038a",
  null
  
)

export default component.exports